import React, { useEffect, useState, useRef } from "react";
import JoditEditor from "jodit-react";
import { getData, postData } from "../../services/Axios/Axios";
import messageService from "../../services/message/messageService";

interface EditableTextPageProps {
  fetchUrl: string; // API URL for GET
  updateUrl: string; // API URL for POST
  title: string; // Optional heading text
}

const EditableTextPage: React.FC<EditableTextPageProps> = ({
  fetchUrl,
  updateUrl,
  title,
}) => {
  const editor = useRef(null);
  const [content, setContent] = useState("");
  const [error, setError] = useState<string | null>(null);

  // Fetch existing content
  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await getData(fetchUrl, { skip_number: 0 });
      const data = response[0]?.description || "";
      setContent(data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Failed to load content.");
    }
  };

  // Strip HTML before sending
  const stripHtmlTags = (html: string) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    try {
      const plainText = stripHtmlTags(content);
      await postData(updateUrl, { description: plainText });

      const messageServices = messageService();
      messageServices.toast("success", messageServices.message.updatedSuccess);
    } catch (error) {
      console.error("Error updating data:", error);
      setError("Failed to update content.");
    }
  };

  const joditConfig = {
    readonly: false,
    placeholder: "Start typing...",
    height: "100%",
    minHeight: "100%",
  };

  return (
    <div className="rightside">
      <div className="allscreen">
        <div className="loadlisting">
          <div className="loadlist">
            {title && (
              <h2 className="text-lg font-semibold mb-3">{title}</h2>
            )}
            <form onSubmit={handleFormSubmit}>
              <div className="tablebox p-3">
                <div className="scrollbar-box newclassscroll h-[60vh]">
                  <JoditEditor
                    ref={editor}
                    value={content}
                    config={joditConfig}
                    onBlur={(newContent) => setContent(newContent)}
                  />
                  {error && <div className="text-error mt-2">{error}</div>}
                  <div className="modalfooterright mt-3">
                    <button type="submit" className="mybtn">
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditableTextPage;
